import React from 'react';
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {useStyles } from './../Complements/usesStyles'
import clsx from "clsx";
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

const MainTwice = props => {
    const {  info, body } = props
    const classes = useStyles(props);
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    return (
        <main className={classes.content}>
            <Container maxWidth="lg" className={classes.container}>
            {
                !isMobile ?
                <Grid container spacing={3}>
                    {/* Recent Deposits */}
                    <Grid item xs={12} md={12} lg={6}>
                        <Paper className={fixedHeightPaper}> { info } </Paper>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <Paper className={fixedHeightPaper}> { body } </Paper>
                    </Grid>
                </Grid> :
                <Grid container spacing={3}>
                     <Grid item xs={12} md={12} lg={12}>
                        <Paper >{ info }</Paper>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <Paper className={fixedHeightPaper}> { body } </Paper>
                    </Grid>
                   
                </Grid>
            }
                
            </Container>
        </main>
    );
};

MainTwice.propTypes = {
    info: PropTypes.node.isRequired,
    body: PropTypes.node.isRequired,
};

export default MainTwice;